
import bus from '@/util/useBus'

export default (key: string) => {
  bus.emit('dblclickSearch', key)
}
